export default __webpack_public_path__ + "static/media/Competition_purple.95d7e9d8.svg";